<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;">				
				<Biaodan v-model="value.shu" :ming='"biaoti"+i'></Biaodan>	
				<el-checkbox v-model="value.gengduo" >是否显示 【查看更多】</el-checkbox>
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<!-- <el-input placeholder="请输入内容" v-model="value.yangshi.gao">
				<template slot="prepend">Http://</template>
			</el-input> -->
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Biaodan from '../Biaodan.vue'
	export default {
		name: 'Biaoti',
	  data () {
		  return {
			 checked: true
		  };
		},
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},
		
		components:{Biaodan},

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
